import '../App.css';
const paragraphStyle = {
	fontSize: '16px',
	color: 'white',
	lineHeight: '1.5',
};
const Gettoknow = () => {
	return (
		<div>
			<main>
				<div className="container">
					<div className="header-title center">
						<h1>GET TO KNOW ABOUT US</h1> 
					</div>
					<div>
						<h3 style={{ fontSize: '18px' }}><strong>SIMS Tree</strong></h3>
						<p style={paragraphStyle}>
							SIMS Tree: Revolutionizing HSE Solutions through Intelligent Management system.
						</p>
						<p style={paragraphStyle}>
							Our team recognized the immense significance of our idea and conducted thorough research, drawing upon our extensive experience. With a clear understanding of our objectives, we meticulously devised a comprehensive plan. This led to the development of SIMS (Smart Intelligent Management System), an innovative solution designed to not only provide HSE (Health, Safety, and Environment) solutions but also propel the advancement of the HSE AI domain. SIMS aims to create a world that is free from hazards, risks, and any detrimental outcomes that could potentially harm individuals, assets, the environment, or an organization's reputation.
						</p>
						<p style={paragraphStyle}>
							In our pursuit of excellence, we identified novel factors that form the foundation of a new philosophy, enhancing human cognition to align with an organization's safety culture. Our focus lies on knowledge, actions, and behaviors, integrating them intelligently. Consequently, we crafted a sophisticated AI-driven management system, exclusively dedicated to HSE solutions. Through extensive analysis, we have gained a profound understanding of what true HSE entails and comprehend its deep-rooted significance within organizations. Furthermore, we possess the vision for a comprehensive structure that encompasses our national commitment to authentic HSE.
						</p>
						<p style={paragraphStyle}>
							Our system is designed to preemptively avert any negative consequences and guide human behavior towards safeguarding HSE principles. The overarching goal is to implement and ingrain a culture of HSE. To accomplish this, we seek out talented individuals capable of contributing to the development of SIMS AI. These individuals are entrusted with the responsibility of instilling the proper mindset required for creating SIMS AI.
						</p>
						<p style={paragraphStyle}>
							To achieve our vision, we bring together three fundamental elements: knowledge, action, and behavior. By delivering relevant and accurate information, we aim to influence and direct actions, consequently fostering a change in behavior. Moreover, our system takes into account the physical, mental, and emotional aspects of individuals. Through a carefully devised framework, we induce physical effects that impact human behavior, intertwining mental comprehension with acquired knowledge. This holistic approach allows us to guide and shape emotional responses in a desired manner.
						</p>
						<p style={paragraphStyle}>
							SIMS Tree represents a paradigm shift in HSE management, merging intelligent technology with a comprehensive understanding of human behavior. Our ultimate objective is to create a safer world, where HSE is not just an organizational requirement but a deeply ingrained value in society.
						</p>
						<p style={paragraphStyle}>
							<strong>SIMS</strong> is bigger than what is imagined. It’s a global HSE problem solving solution. The benefit of using such a system is limitless. 
						</p>
					</div>
					{/* <div class="gettoknow-list">
						<div class="gettoknow-item">
							<div class="gettoknow-itemin" id="<?=$this->GetEditAreaId($arItem['ID']);?>">
								<div class="gettoknow-item-pic"><img src="img/gettoknow1.jpg"/></div>
								<div class="gettoknow-item-other">
									<div class="gettoknow-item-text">Description: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut l
			abore et dolore magna aliqua.  Ut enim ad minim veniam, quis nostrudexercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
									<div class="gettoknow-item-title">First Name, Last Name</div>

								</div>
							</div>
						</div>
						<div class="gettoknow-item">
							<div class="gettoknow-itemin" id="<?=$this->GetEditAreaId($arItem['ID']);?>">
								<div class="gettoknow-item-pic"><img src="img/gettoknow2.jpg"/></div>
								<div class="gettoknow-item-other">
									<div class="gettoknow-item-text">Description: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut l
			abore et dolore magna aliqua.  Ut enim ad minim veniam, quis nostrudexercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</div>
									<div class="gettoknow-item-title">First Name, Last Name</div>

								</div>
							</div>
						</div>
					</div> */}
				</div>
			</main>
		</div>
	)
}
export default Gettoknow;